import { useNavigate } from 'react-router'
import { links } from '@/utils/link'
import { JobNotSupported } from '@/features/call-center/components/JobNotSupported'

export function JobNotSupportedContainer() {
  const navigate = useNavigate()
  return (
    <JobNotSupported onBackToCallCenter={() => navigate(links.callCenter())} />
  )
}
